import * as React from 'react';

type Props = {
  children: React.ReactNode
};

const SidePanel = ({
  children
}: Props) => (
  <section className="side-panel">
    {children}
  </section>
);

export default SidePanel;
